import MaterialStep, { StepProps } from '@mui/material/Step';

function Step(props: StepProps) {
    return <MaterialStep data-testid={'Step-container'} {...props} />;
}

export default Step;
